<template>
    <v-dialog v-model="getModalEnviarEmailPedidoCompra" max-width="720px" transition="dialog-transition">
        <v-card outlined>
            <v-card-title>Enviar pedido de compra por e-mail</v-card-title>
            <v-form ref="form" class="px-3">
            <v-card-text :loading="$store.getters.getOverlay">
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field
                                label="E-mail"
                                v-model="getContato.email"
                                outlined
                                dense
                                :rules="rules.email"
                                class="mr-2 ml-2"
                                @keyup.enter="enviar"
                                type="email"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-form>
            <v-card-actions>
                <v-btn color="default" @click="setModalEnviarEmailPedidoCompra(false)" :loading="$store.getters.getOverlay" outlined>Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="enviar" :loading="$store.getters.getOverlay" outlined>Enviar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        data(){
            return{
                rules: {
                    email: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                },
            }
        },
        computed: {
            ...mapGetters([
                'getModalEnviarEmailPedidoCompra',
                'getContato',
                'getPedidoCompra'
            ])
        },
        methods: {
            ...mapActions([
                'enviarEmailPedidoCompra',
                'setModalEnviarEmailPedidoCompra'
            ]),
            enviar(){
                if(this.$refs.form.validate()){
                    this.enviarEmailPedidoCompra({
                        pedido_id: this.getPedidoCompra.id,
                        email: this.getContato.email,
                    })
                }
            }

        },
        
    }
</script>